import { getOrderClientSubscriptionMy } from '~/api/module/rights.ts'
import type { ISubscription } from '~/api/interface/order.ts'

export interface IRightsConfig {
  cycle: string | 'annual' | 'monthly' | 'person' | 'team' // 按年/按月/按个人/按团队
  subscription: ISubscription | null
}

export const useRightsConfig = () =>
  useState<IRightsConfig>('overseasGlobalConfig', () => {
    return {
      cycle: isGlobalVersion() ? 'annual' : 'person',
      subscription: null,
    }
  })

export const actionUpdateCycle = (v: IRightsConfig['cycle']) => {
  const state = useRightsConfig()
  state.value.cycle = v
  trackEvent(TRACK_EVENT.CLICK_SUBSCRIBE_PACKAGE_SWITCH, {
    cycle: v,
  })
}

export const actionSetupMySubscriptions = async () => {
  const state = useRightsConfig()
  const res = await useAsyncData(() => getOrderClientSubscriptionMy())
  if (res.data.value?.data) {
    state.value.subscription = res.data.value?.data
  }
}
